module.exports = __webpack_public_path__ + "img/icn_technology.497492c7.svg";